import $ from 'jquery/dist/jquery.js';
window.$ = window.jQuery = $;
